export const FieldRendererName = 'fieldRendererComponent';
